// Sentry initialization should be imported first!
import "@src/sentry-init";
import { ErrorBoundary } from "@components/error-boundary/error-boundary";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@store/store";
import { StrictMode } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "@router/router";
import { TrackEventInitializer } from "@loaders/track-event-initializer";
import { CookieManagerLoader } from "@loaders/cookie-manager-loader";
import { hbTheme } from "@utils/styles/hb-theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { FaroThemeProvider, ToastProvider } from "@flat-ui";
import { ColorSchemeSync } from "@components/color-scheme-sync";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <CookieManagerLoader>
      <FaroThemeProvider theme={hbTheme} storageManager={null}>
        <Provider store={store}>
          <ColorSchemeSync>
            <ToastProvider>
              <TrackEventInitializer>
                <ErrorBoundary>
                  <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <RouterProvider
                      router={router}
                      future={{
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        v7_startTransition: true,
                      }}
                    />
                  </LocalizationProvider>
                </ErrorBoundary>
              </TrackEventInitializer>
            </ToastProvider>
          </ColorSchemeSync>
        </Provider>
      </FaroThemeProvider>
    </CookieManagerLoader>
  </StrictMode>
);
